import { useMemo } from 'react';
import { defineMessages, MessageDescriptor, useIntl } from 'react-intl';
import { LearningFeature, LearningFeatureType } from 'src/api/learningQueue/types';
import { featureTypeToLicType } from '../constants';
import { Lesson } from '../types';

export const featureTitles: Record<LearningFeatureType, MessageDescriptor> = defineMessages({
  learn: { id: 'learnq_lessons_preview_title_learn' },
  pronunciation: { id: 'learnq_lessons_preview_title_pronunciation' },
  review: { id: 'learnq_lessons_preview_title_review' },
  video: { id: 'learnq_lessons_preview_title_immerse' },
  conversation: { id: 'learnq_lessons_preview_title_communicate' },
  sentence_builder: { id: 'learnq_lessons_preview_title_sentence' },
});

export const useConvertedLessons = (
  learningFeatures: LearningFeature[] | undefined,
): Lesson[] | undefined => {
  const intl = useIntl();

  return useMemo(
    () =>
      learningFeatures
        ? learningFeatures.map(f => ({
            ...f,
            title: intl.formatMessage(featureTitles[f.type]),
            licType: featureTypeToLicType[f.type],
          }))
        : undefined,
    [learningFeatures, intl],
  );
};
